import React from "react";
import Layout from "@/components/layout/Layout";
import { CareChat } from "@/components/care-chat/CareChat";
import { SEOHead } from "@/components/seo/SEOHead";

export default function ConsultationsPage() {
  return (
    <Layout hideFooter>
      <SEOHead 
        title="Care Advisor Chat | Grandpal"
        description="Get free, instant guidance on nursing home care, the Fair Deal scheme, and home care options in Ireland. Chat with our AI-powered Care Advisor."
        canonicalUrl="/consultations"
      />
      <CareChat />
    </Layout>
  );
}
